export default function getSEWPHomeURL() {
  return '/content/insight-web/en_US/client/sewp.html'
}
